import { useLocalization } from "@fluent/react";
import { Chip, Radio } from "@narmi/design_system";
import type { DeliverySpeedOption } from "./useDeliverySpeedOptions";
import styles from "./DeliverySpeedSection.module.scss";

type SingleExpediteDeliverySpeedCardsProps = {
  options: DeliverySpeedOption[];
  selectedValue: string;
  onSelect: (value: string) => void;
};

const SingleExpediteDeliverySpeedCards = ({
  options,
  selectedValue,
  onSelect,
}: SingleExpediteDeliverySpeedCardsProps) => {
  const { l10n } = useLocalization();

  return (
    <div className={styles.deliverySpeedSelectContainer}>
      {options.map((option) => (
        <Radio
          key={option.value}
          name="delivery-speed"
          value={option.value}
          kind="input-card"
          checked={selectedValue === option.value}
          onCheck={() => onSelect(option.value)}
        >
          <div className={styles.radioCardContent}>
            <div className={styles.radioCardHeader}>
              <div className={styles.radioCardHeaderLeft}>
                <p className={styles.radioCardLabel}>{option.label}</p>
                {option.expedite ? (
                  <span className={styles.expediteChip}>
                    <Chip
                      kind="info"
                      label={l10n.getString("tag-expedite")}
                      startIcon={
                        option.expediteIcon === "clock" ? "clock" : "zap"
                      }
                    />
                  </span>
                ) : null}
              </div>
              <p className={styles.radioCardDescription}>
                <span className={styles.radioCardDescriptionArrival}>
                  {option.arrival}
                </span>
                <span
                  aria-hidden="true"
                  className={styles.radioCardDescriptionText}
                >
                  {" "}
                  ·{" "}
                </span>
                <span className={styles.radioCardDescriptionFee}>
                  {option.fee}
                </span>
              </p>
            </div>
          </div>
        </Radio>
      ))}
    </div>
  );
};

export default SingleExpediteDeliverySpeedCards;
